import { observer } from 'mobx-react-lite'
import { type TeamMembersViewModel } from '@/features/iam/teams/TeamMembersViewModel'
import { SearchBar } from '@/features/iam/teams/components/SearchBar'
import { MembersTableContainer } from '@/features/iam/teams/components/MembersTable/MembersTableContainer'
import { PendingMembersTableContainer } from '@/features/iam/teams/components/PendingMembersTable/PendingMembersTableContainer'
import { RemoveTeamMemberDialogContainer } from '@/features/iam/teams/RemoveTeamMemberDialog/RemoveTeamMemberDialogContainer'
import { InviteTeamMemberModalContainer } from '@/features/iam/teams/InviteTeamMemberModal/InviteTeamMemberModalContainer'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { match } from '@/utils/pattern-match-util'
import {
  MembersListHeader,
  TeamMembers,
  TeamMembersLayout,
} from '@/features/iam/teams/components/TeamMembers'

export interface TeamMembersContainerProps {
  vm: TeamMembersViewModel
}

export const TeamMembersContainer = observer(function TeamMembersContainer({
  vm,
}: TeamMembersContainerProps) {
  return (
    <TeamMembersLayout
      dialogs={
        <>
          <InviteTeamMemberModalContainer vm={vm.inviteTeamMemberModalVm} />
          <RemoveTeamMemberDialogContainer vm={vm.removeTeamMemberDialogVm} />
        </>
      }
    >
      {vm.fetch.match({
        pending: () => <ContentLoading />,
        rejected: (err: unknown) => <ContentError error={err} />,
        resolved: () => (
          <TeamMembers
            header={
              <MembersListHeader
                visibleKind={vm.visibleKind}
                currentCount={vm.teamMembers.length}
                pendingCount={vm.pendingTeamMembers.length}
                isDropdown={vm.hasPendingMembers && vm.canManageTeamMember}
                onVisibleKindChange={vm.setVisibleKind}
              />
            }
            searchBar={
              <SearchBar
                searchText={vm.searchText}
                onSearchTextChange={vm.setSearchText}
                canManageTeamMember={vm.canManageTeamMember}
                onInvite={vm.showInviteModal}
              />
            }
            table={match(vm.visibleKind, {
              Current: () => <MembersTableContainer vm={vm} />,
              Pending: () => (
                <PendingMembersTableContainer vm={vm.pendingMembersVm} />
              ),
            })}
          />
        ),
      })}
    </TeamMembersLayout>
  )
})
